export default "__VITE_ASSET__DAa6K$Um__"